import { clsx, ClassValue } from "clsx";
import { twMerge } from "tailwind-merge"; // Optional: for merging Tailwind classes
import { Participant } from "../models/Participant";

export const clean = (obj: Record<string, any>): Record<string, any> => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === "object") clean(obj[key]);
    else if (obj[key] === undefined) delete obj[key];
    else if (obj[key] === null) delete obj[key];
    else if (obj[key] === "") delete obj[key];
    else if (Array.isArray(obj[key]) && obj[key].length === 0) delete obj[key];
  });
  return obj;
};

export const topLevelClean = (
  obj: Record<string, any>,
): Record<string, any> => {
  const stack = [obj];

  while (stack.length) {
    const current = stack.pop();

    if (typeof current !== "object" || current === null) continue;

    Object.keys(current).forEach((key) => {
      const value = current[key];

      // If value is an object, push it to the stack
      if (value && typeof value === "object") {
        stack.push(value);
      }

      // Remove empty values: undefined, null, or empty string
      if (value === undefined || value === null || value === "") {
        delete current[key];
      }
    });
  }

  return obj;
};

export const cleanParticipantText = (
  text: string,
  participants: Participant[],
) => {
  let cleanedText = text;

  participants.forEach((participant) => {
    let namePattern = new RegExp(`<participantId:${participant._id}>`, "g");
    return (cleanedText = cleanedText.replace(namePattern, participant.name));
  });

  return cleanedText;
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs));
}
